import { render, staticRenderFns } from "./HomeLeaderboard.vue?vue&type=template&id=42b73683&scoped=true"
import script from "./HomeLeaderboard.vue?vue&type=script&lang=js"
export * from "./HomeLeaderboard.vue?vue&type=script&lang=js"
import style0 from "./HomeLeaderboard.vue?vue&type=style&index=0&id=42b73683&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b73683",
  null
  
)

export default component.exports